import React from 'react'

function ForComLice() {
  return (
    <>
     <head style={{all:'initial'}}>
                <title>ترخيص تجارة الجملة للأجانب</title>
                <meta name="description" content="تجارة الجملة للأجانب"/>
                <meta name="keywords" content="ترخيص تجارة الجملة للأجانب" />
            </head>
      <div style={{ padding: '50px', fontSize: '10px' }}>
          <h1>
              تقدم الخدمة للمنشآت الاجنبية 100% والتي ترغب في
              <br />
              ممارسة نشاط تجارة الجملة والتجزئة في المملكة أو التجارة
              <br />
              الالكترونية.
              </h1>
      </div>
    </>
  )
}

export default ForComLice